import React from 'react';
import styles from './EmptyTableRow.module.css';

interface EmptyTableRowProps {
  action?: {
    label: string;
    onClick: () => void;
  };
  colSpan: number;
  message: string;
}

const EmptyTableRow = ({
  action,
  colSpan,
  message,
}: EmptyTableRowProps) => (
  <tr className={styles.emptyTableRow}>
    <td colSpan={colSpan}>
      <div>{message}</div>
      {
        action && (
          <button
            className={styles.emptyTableRowAction}
            onClick={action.onClick}
            type="button"
          >
            {action.label}
          </button>
        )
      }
    </td>
  </tr>
);

export default EmptyTableRow;
